import { preprocessEmptyStringAsUndefined } from '@dealstack/shared/lib/common/common';
import { z } from 'zod';

export const AllocationShape = z.object({
	mipId: z.string(),
	allocation: z.preprocess(preprocessEmptyStringAsUndefined, z.number().positive()),
});
export type AllocationFormDto = z.infer<typeof AllocationShape>;
